export default "__VITE_ASSET__454cca16__"